import React, { useState } from "react";
import axios from "axios"; // Import axios
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from 'utlis/commonfunctions';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import swal from "sweetalert";
import Loader from "./loader";


const SERVER_URL = process.env.REACT_APP_API_URL;

const MobileVerification = ({setPlanData, handleLimit, handlePage, queuedMobile, balanceQueue}) => {

    const [mobileNumber, setMobileNumber] = useState("");
    const [loading, setLoading] = useState(false);

    const handleVerifyClick = async () => {

        setLoading(true)

        if (!mobileNumber) {
            swal("", "Please enter a valid mobile number", "warning");
            setLoading(false);
            return;
        }
        try {
            const headers = await getApiHeader();
            const response = await axios.post(
                `${SERVER_URL}recharge-voucher-queueing/check-mobile-number`,
                { mobile_number: mobileNumber },
                { headers }
            );

            // console.log("=====================data========================================");
            // console.log(response.status);
            // console.log(response.data);
            // console.log(response.data.data.plan);
            // console.log(response.data.data.queuing_count);
            // console.log("=======================end======================================");
            if (response.status === 200) {
                setPlanData(response.data.data.plan);
                handleLimit(response.data.data.max_queued_recharge_voucher_count);
                balanceQueue(response.data.data.balanceQueuedMsgText);
                queuedMobile(mobileNumber);
                handlePage('plan');
            }

        } catch (error) {
            if(error.response?.data?.message !== undefined){
                const message=error.response?.data?.message;
                swal("", message, "warning");
            }else{
                swal("", "Something went wrong, Please try again", "warning");
            }
            
            setLoading(false);
        } finally {
            setLoading(false);
        }

    };



    const MobileValidation = (value) => {

        const isValid = /^0\d*$/.test(value) || value === '';
        if (isValid) {
            if (value.length < 2 || value.startsWith('04')) {
                const numericValue = value.replace(/[^0-9]/g, "");
                setMobileNumber(numericValue);
            }
        }
    };



    return (
        <>  
            <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                    <h6>Verify Mobile Number</h6>
                    <hr />


                    {loading === true && (
                        <Loader />
                    )}
                    <br/>

                     <div className="formbold-mb-5 formbold-pt-3  col-lg-6 col-md-12 col-sm-12">
                        <label className="formbold-form-label formbold-form-label-2">Enter Mobile Number For Voucher Queueing <span className="madate_mark">*</span></label>
                        <div className="input-group">
                            <input type="text" className="formbold-form-input addInput" maxLength="10" variant="outlined" placeholder="Enter Mobile Number" keyboardType="numeric" value={mobileNumber} autoComplete="off" onChange={(e) => MobileValidation(e.target.value)} 
                                style={{ width: '70%' }} />
                            <div className="input-group-append spc-exitotp-width">
                                <button className="btn btn-send-otp add-mb-otp-btn" type="button" onClick={() => handleVerifyClick()} > Verify to Continue </button>
                            </div>
                        </div>
                        
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                </div>
            </div>

        </>
    );
}

export default MobileVerification;
